<div *ngIf="isLoading">
    <mat-spinner
        class="sb-mx-auto"
        color="accent"
        diameter="30"
        id="{{ context.widgetId }}"
    ></mat-spinner>
</div>
<div>
    <mat-form-field class="mat-form-field-full-width" appearance="outline">
        <mat-label>{{ context.label }}</mat-label>
        <mat-select
            [(ngModel)]="selectedOption"
            [compareWith]="compareObjects"
            (selectionChange)="onChange($event)"
            [placeholder]="context.placeHolder"
        >
            <mat-option *ngFor="let option of dataOptions" [value]="option">
                {{ getOptionLabel(option) }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
